import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"
import _imports_0 from '../../assets/submitted-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-body-2 mb-4" }, " Enter the name of your vision insurance provider ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "submitted",
  width: "107",
  height: "107",
  class: "mx-auto mb-2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Account Holder Information", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Give us some information about the account holder", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Your Employment Information", -1)

import { computed, ref } from "vue";
import * as rules from "@/utils/rules";
import states from "@/constants/stateOptions";
import DateInput from "../custom/DateInput.vue";
import VisionProvider from "@/types/VisionProvider";
import VisionVariables from "@/types/VisionVariables";
import FormTitle from "../common/FormTItle.vue";
import { useProviderStore } from "@/stores/Provider";
import { getUserToken } from "@/utils/auth";
import RadioGroup from "../custom/RadioGroup.vue";
import TextInput from "../custom/TextInput.vue";
import SelectInput from "../custom/SelectInput.vue";
import PhoneNumberInput from "../custom/PhoneNumberInput.vue";
import ZipCodeInput from "../custom/ZipCodeInput.vue";
import CustomRadioGroup from "../custom/CustomRadioGroup.vue";

type ProviderOption = {
  value: string;
  title: string;
  image: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'InsuranceInformation',
  props: {
    modelValue: {},
    providers: {}
  },
  emits: ["update:modelValue", "insurance-status-changed"],
  setup(__props: any, { emit }) {

const props = __props;



const sessionId = getUserToken();

const handleProviderSelection = () => {
  emit("insurance-status-changed", !!isNotListed.value);
};
const variables = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
const isAccountHolderQuestion = `Is ${variables.value.firstName} ${variables.value.lastName} the primary account holder?`;
const relationshipQuestion = `What is ${variables.value.firstName} ${variables.value.lastName}'s relationship to the account holder?`;

const isAdult = computed(() => {
  const birthDate = new Date(props.modelValue.dateOfBirth!);
  const currentDate = new Date();
  let age = currentDate.getFullYear() - birthDate.getFullYear();

  if (
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() &&
      currentDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age >= 18;
});

const isNotListed = ref(false);
const providerName = ref("");
const isActive = ref(false);

const selectedProvider = computed(() =>
  props.providers.find(
    (provider) => provider.name === variables.value.planAdministrator
  )
);

// We map into the format that the v-autocomplete component expects
const providerOptions = computed((): ProviderOption[] =>
  props.providers
    .filter((provider) => !!provider.workflow)
    .map((provider) => ({
      value: provider.name,
      title: provider.name,
      image: provider.image,
    }))
);

const formOptions = computed(() => selectedProvider.value?.formOptions || {});

// To do: Maybe move account holder info to another variable
function clearAccountHolderInfo() {
  variables.value.accountHolderLastName = undefined;
  variables.value.accountHolderFirstName = undefined;
  variables.value.accountHolderMiddleInitial = undefined;
  variables.value.accountHolderDateOfBirth = undefined;
  variables.value.accountHolderEmail = undefined;
  variables.value.accountHolderSex = undefined;
}
function setUserInfoToAccountHolder() {
  variables.value.accountHolderLastName = variables.value.lastName;
  variables.value.accountHolderFirstName = variables.value.firstName;
  variables.value.accountHolderMiddleInitial = variables.value.middleInitial;
  variables.value.accountHolderDateOfBirth = variables.value.dateOfBirth;
  variables.value.accountHolderEmail = variables.value.email;
  variables.value.accountHolderSex = variables.value.sex;
}

function onChangeAccountHolderOption() {
  variables.value.accountHolderAddressState = variables.value.addressState;
  variables.value.accountHolderAddressCity = variables.value.addressCity;
  variables.value.accountHolderAddressZip = variables.value.addressZip;
  variables.value.accountHolderAddressStreet = variables.value.addressStreet;
  variables.value.accountHolderAddressStreet2 = variables.value.addressStreet2;
  variables.value.accountHolderPhoneNumber = variables.value.phoneNumber;
  variables.value.accountHolderSex = variables.value.sex;

  if (variables.value.isAccountHolder) {
    setUserInfoToAccountHolder();
  } else {
    clearAccountHolderInfo();
  }
}
function onChangeRelationshipOption() {
  variables.value.relationshipToAccountHolder =
    variables.value.relationshipOption !== "Other"
      ? variables.value.relationshipOption
      : undefined;
  variables.value.isChildFullTimeStudent = undefined;
  variables.value.schoolName = undefined;
  variables.value.isChildPhysicallyImpaired = undefined;
}

function getDomainFromUrl(url: string) {
  const cleanedUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
  const domain = cleanedUrl.split("/")[0];
  return domain;
}

async function onClickSubmit() {
  const domain = getDomainFromUrl(window.location.href);
  try {
    await useProviderStore().addNotSupported({
      name: providerName.value,
      reimbursementType: "vision",
      sessionLink: `https://${domain}/start/${sessionId}`,
      userEmail: variables.value.email!,
      sessionId,
    });
  } catch (error) {
    // TODO: Handle error
  } finally {
    isActive.value = true;
  }
}

const visionPlanTypeRule = (v: string | undefined) =>
  !v ||
  v == "PPO" ||
  "We currently do not support claims for this type of plan";

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(FormTitle, {
            title: "Insurance Information",
            description: "Give us some information about vision insurance provider"
          })
        ]),
        _: 1
      }),
      (!isNotListed.value)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            md: "7",
            class: "pb-0 pt-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_autocomplete, {
                class: "vision-insurance-provider-input",
                items: providerOptions.value,
                label: "Vision Insurance Provider",
                "menu-icon": "",
                "append-inner-icon": "mdi-magnify",
                variant: "outlined",
                modelValue: variables.value.planAdministrator,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((variables.value.planAdministrator) = $event)),
                rules: [rules.requiredRule]
              }, {
                chip: _withCtx(({ item }) => [
                  _createVNode(_component_v_chip, {
                    class: "avatar-chip v-avatar",
                    variant: "text",
                    "prepend-avatar": item?.raw?.image,
                    text: item.raw.title
                  }, null, 8, ["prepend-avatar", "text"])
                ]),
                item: _withCtx(({ props, item }) => [
                  _createVNode(_component_v_list_item, _mergeProps({ class: "custom-avatar" }, props, {
                    "prepend-avatar": item?.raw?.image
                  }), null, 16, ["prepend-avatar"])
                ]),
                _: 1
              }, 8, ["items", "modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "5",
        class: "pb-0 pt-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_checkbox, {
            color: "primary",
            label: "My vision insurance provider is not listed",
            modelValue: isNotListed.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isNotListed).value = $event)),
            onChange: handleProviderSelection
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (isNotListed.value)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            cols: "12",
            class: "px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(TextInput, {
                variant: "outlined",
                label: "Vision insurance provider name",
                modelValue: providerName.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((providerName).value = $event)),
                rules: [rules.requiredRule],
                required: ""
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_btn, {
                class: "mt-3",
                color: "primary",
                onClick: onClickSubmit,
                disabled: providerName.value.length === 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Submit ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_dialog, {
                modelValue: isActive.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isActive).value = $event)),
                width: "500"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    title: "",
                    style: {"padding":"60px","border-radius":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_v_card_title, { class: "pa-0 mb-3" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Thank you for submitting this information. ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "text-center text-body-2 pa-0 mb-10" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Your vision plan provider has not been added to our platform yet. We will notify you via email when we add it and then you will be able to resume your claim. ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        text: "Close",
                        class: "mx-auto",
                        style: {"min-width":"148px"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (isActive.value = false))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!isNotListed.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_v_col, {
              cols: 12,
              class: "pt-0 mb5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "radio-container",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CustomRadioGroup, {
                      label: "Are you the primary account holder?",
                      label2: isAccountHolderQuestion,
                      modelValue: variables.value.isAccountHolder,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((variables.value.isAccountHolder) = $event)),
                      rules: [rules.requiredRule],
                      onChange: onChangeAccountHolderOption,
                      options: [
              {
                label: 'Yes, the insurance plan is in my name.',
                value: true,
              },
              {
                label: 'No, the insurance plan belongs to a family member.',
                value: false,
              },
            ],
                      required: "",
                      isInsurance: true
                    }, null, 8, ["modelValue", "rules", "options"]),
                    (variables.value.isAccountHolder == false)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(CustomRadioGroup, {
                            label: "Relationship to account holder",
                            label2: relationshipQuestion,
                            modelValue: variables.value.relationshipOption,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((variables.value.relationshipOption) = $event)),
                            onChange: onChangeRelationshipOption,
                            rules: [rules.requiredRule],
                            options: [
                {
                  label: 'Spouse/Partner',
                  value: 'Spouse/Partner',
                },
                {
                  label: 'Child',
                  value: 'Child',
                },
                {
                  label: 'Other',
                  value: 'Other',
                },
              ],
                            required: "",
                            isInsurance: true
                          }, null, 8, ["modelValue", "rules"]),
                          (variables.value.relationshipOption == 'Other')
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TextInput, {
                                    variant: "outlined",
                                    label: "Enter your relationship to account holder",
                                    modelValue: variables.value.relationshipToAccountHolder,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((variables.value.relationshipToAccountHolder) = $event)),
                                    rules: [rules.requiredRule],
                                    required: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (
              isAdult.value &&
              variables.value.relationshipOption === 'Child' &&
              formOptions.value.hasChildStudent
            )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_v_radio_group, {
                            label: "Is the child a full time student?",
                            modelValue: variables.value.isChildFullTimeStudent,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((variables.value.isChildFullTimeStudent) = $event)),
                            rules: [rules.requiredRule],
                            inline: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Yes",
                                value: true
                              }),
                              _createVNode(_component_v_radio, {
                                label: "No",
                                value: false
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"]),
                          (variables.value.isChildFullTimeStudent)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TextInput, {
                                    variant: "outlined",
                                    label: "Enter the School Name",
                                    modelValue: variables.value.schoolName,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((variables.value.schoolName) = $event)),
                                    rules: [rules.requiredRule],
                                    required: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_radio_group, {
                            label: "Is the child physically impaired?",
                            modelValue: variables.value.isChildPhysicallyImpaired,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((variables.value.isChildPhysicallyImpaired) = $event)),
                            rules: [rules.requiredRule],
                            inline: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Yes",
                                value: true
                              }),
                              _createVNode(_component_v_radio, {
                                label: "No",
                                value: false
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (variables.value.isAccountHolder === false)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pb-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        variant: "outlined",
                        label: "First name",
                        modelValue: variables.value.accountHolderFirstName,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((variables.value.accountHolderFirstName) = $event)),
                        rules: [rules.requiredRule],
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        variant: "outlined",
                        label: "Last name",
                        modelValue: variables.value.accountHolderLastName,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((variables.value.accountHolderLastName) = $event)),
                        rules: [rules.requiredRule],
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        variant: "outlined",
                        label: "Middle initial (optional)",
                        modelValue: variables.value.accountHolderMiddleInitial,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((variables.value.accountHolderMiddleInitial) = $event)),
                        rules: [rules.middleInitialRule]
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        variant: "outlined",
                        label: "Email address",
                        modelValue: variables.value.accountHolderEmail,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((variables.value.accountHolderEmail) = $event)),
                        rules: [rules.requiredRule],
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PhoneNumberInput, {
                        modelValue: variables.value.accountHolderPhoneNumber,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((variables.value.accountHolderPhoneNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DateInput, {
                        variant: "outlined",
                        label: "Date of Birth",
                        modelValue: variables.value.accountHolderDateOfBirth,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((variables.value.accountHolderDateOfBirth) = $event)),
                        rules: [rules.requiredRule]
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomRadioGroup, {
                        label: "Sex",
                        modelValue: variables.value.accountHolderSex,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((variables.value.accountHolderSex) = $event)),
                        rules: [rules.requiredRule],
                        options: [
              { label: 'Male', value: 'male' },
              { label: 'Female', value: 'female' },
            ],
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "8",
                    lg: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        label: "Street Address",
                        modelValue: variables.value.accountHolderAddressStreet,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((variables.value.accountHolderAddressStreet) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(TextInput, {
                        label: "Street Address 2",
                        modelValue: variables.value.accountHolderAddressStreet2,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((variables.value.accountHolderAddressStreet2) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        label: "City",
                        modelValue: variables.value.accountHolderAddressCity,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((variables.value.accountHolderAddressCity) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectInput, {
                        items: _unref(states),
                        label: "State",
                        modelValue: variables.value.accountHolderAddressState,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((variables.value.accountHolderAddressState) = $event)),
                        rules: [rules.requiredRule],
                        required: ""
                      }, null, 8, ["items", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ZipCodeInput, {
                        label: "Zip Code",
                        modelValue: variables.value.accountHolderAddressZip,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((variables.value.accountHolderAddressZip) = $event)),
                        rules: [rules.requiredRule, rules.zipCodeRule],
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (formOptions.value.hasEmployerAddress)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        label: "Employer Street Address",
                        modelValue: variables.value.accountHolderEmployerAddressStreet,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((variables.value.accountHolderEmployerAddressStreet) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(TextInput, {
                        label: "Employer Street Address 2",
                        modelValue: variables.value.accountHolderEmployerAddressStreet2,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((variables.value.accountHolderEmployerAddressStreet2) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TextInput, {
                        label: "Employer City",
                        modelValue: variables.value.accountHolderEmployerAddressCity,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((variables.value.accountHolderEmployerAddressCity) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectInput, {
                        items: _unref(states),
                        label: "Employer State",
                        modelValue: variables.value.accountHolderEmployerAddressState,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((variables.value.accountHolderEmployerAddressState) = $event)),
                        required: ""
                      }, null, 8, ["items", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ZipCodeInput, {
                        label: "Employer Zip Code",
                        modelValue: variables.value.accountHolderEmployerAddressZip,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((variables.value.accountHolderEmployerAddressZip) = $event)),
                        rules: [rules.requiredRule, rules.zipCodeRule],
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4",
              class: "pb-0"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  label: "Vision Plan Name",
                  modelValue: variables.value.visionPlanName,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((variables.value.visionPlanName) = $event)),
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4",
              class: "vision-plan-text"
            }, {
              default: _withCtx(() => [
                _createVNode(SelectInput, {
                  label: "Vision Plan Type",
                  modelValue: variables.value.visionPlanType,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((variables.value.visionPlanType) = $event)),
                  items: ['HMO', 'EOS/EPO', 'PPO', 'I don\'t know'],
                  rules: [rules.requiredRule, visionPlanTypeRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4",
              class: "pb-0"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  label: "Vision Plan Group Number",
                  modelValue: variables.value.visionPlanGroupNumber,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((variables.value.visionPlanGroupNumber) = $event)),
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4",
              class: "py-0"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  label: "Member ID or Account Number",
                  modelValue: variables.value.memberId,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((variables.value.memberId) = $event)),
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4",
              class: "py-0"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  label: "Employer/Company Name",
                  modelValue: variables.value.employerOrCompanyName,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((variables.value.employerOrCompanyName) = $event)),
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (formOptions.value.last4DigitsOfSSN)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: "12",
                  sm: "12",
                  md: "6",
                  lg: "4",
                  class: "py-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TextInput, {
                      variant: "outlined",
                      label: "Last 4 Digits of SSN",
                      modelValue: variables.value.last4DigitsOfSSN,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((variables.value.last4DigitsOfSSN) = $event)),
                      rules: [rules.requiredRule, rules.last4DigitsOfSSNRule],
                      required: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formOptions.value.socialSecurityNumber)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 3,
                  cols: "12",
                  sm: "12",
                  md: "6",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TextInput, {
                      label: "Last 4 Digits of SSN",
                      modelValue: variables.value.last4DigitsOfSSN,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((variables.value.last4DigitsOfSSN) = $event)),
                      rules: [rules.requiredRule, rules.last4DigitsOfSSNRule]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formOptions.value.referenceNumber)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 4,
                  cols: "12",
                  sm: "12",
                  md: "6",
                  lg: "4",
                  class: "py-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TextInput, {
                      label: "Reference Number",
                      modelValue: variables.value.referenceNumber,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((variables.value.referenceNumber) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          variables.value.isAccountHolder === false && formOptions.value.hasMemberEmployed
        )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pb-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { variant: "outlined" }, {
                        default: _withCtx(() => [
                          _createVNode(RadioGroup, {
                            label: "Are You Currently Employed?",
                            modelValue: variables.value.areOtherMembersEmployed,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((variables.value.areOtherMembersEmployed) = $event)),
                            rules: [rules.requiredRule],
                            options: [
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (variables.value.areOtherMembersEmployed)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "8",
                          lg: "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TextInput, {
                              label: "Employer Street Address",
                              modelValue: variables.value.accountHolderEmployerAddressStreet,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((variables.value.accountHolderEmployerAddressStreet) = $event)),
                              required: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(TextInput, {
                              label: "Employer Street Address 2",
                              modelValue: variables.value.accountHolderEmployerAddressStreet2,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((variables.value.accountHolderEmployerAddressStreet2) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TextInput, {
                              label: "Employer City",
                              modelValue: variables.value.accountHolderEmployerAddressCity,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((variables.value.accountHolderEmployerAddressCity) = $event)),
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(SelectInput, {
                              items: _unref(states),
                              label: "Employer State",
                              modelValue: variables.value.accountHolderEmployerAddressState,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((variables.value.accountHolderEmployerAddressState) = $event)),
                              required: ""
                            }, null, 8, ["items", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ZipCodeInput, {
                              label: "Employer Zip Code",
                              modelValue: variables.value.accountHolderEmployerAddressZip,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((variables.value.accountHolderEmployerAddressZip) = $event)),
                              rules: [rules.requiredRule, rules.zipCodeRule],
                              required: ""
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "4",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TextInput, {
                              label: "Your Social Security Number",
                              modelValue: variables.value.otherMemberSocialSecurityNumber,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((variables.value.otherMemberSocialSecurityNumber) = $event)),
                              rules: [rules.requiredRule, rules.socialSecurityNumberRule]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (formOptions.value.employmentStatus)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 6,
                  cols: "12",
                  sm: "12",
                  md: "6",
                  lg: "4",
                  class: "py-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SelectInput, {
                      items: ['Employed', 'Student', 'Neither'],
                      label: "Employment Status",
                      modelValue: variables.value.employmentStatus,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((variables.value.employmentStatus) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formOptions.value.accountHolderEmployment)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 7,
                  cols: "12",
                  sm: "12",
                  md: "6",
                  lg: "4",
                  class: "py-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SelectInput, {
                      variant: "outlined",
                      label: "Cardholder Employment",
                      modelValue: variables.value.accountHolderEmployment,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((variables.value.accountHolderEmployment) = $event)),
                      items: ['Active', 'Retired', 'Hourly', 'Salaried'],
                      rules: [rules.requiredRule],
                      required: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})